exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clients ul[data-v-bca919e2]{width:106%;margin:0 -3%;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}@media screen and (max-width:639px){.clients ul[data-v-bca919e2]{width:100%;margin:0}}", ""]);

// exports
